// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lusickipehpranrjynvx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx1c2lja2lwZWhwcmFucmp5bnZ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc3MjEyMDYsImV4cCI6MjA2MzI5NzIwNn0.1N6CsPRyuW2xfaMh5B9p9g3ec2BjEtDKrjev6JufGM4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);